<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        
                                        <v-col lg="2" md="2" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">
                                            <v-autocomplete
                                                label="Warehouse"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                item-value="id"
                                                :item-title="(item) => `${item.name}`"
                                                :error-messages="warehouse_id.errorMessage.value"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">
                                            <v-autocomplete
                                                label="Customer"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="customer_id.value.value"
                                                :items="getCustomerList"
                                                item-value="id"
                                                :item-title="(item) => `${item.name}`"
                                                :error-messages="customer_id.errorMessage.value"
                                                clearable
                                            />
                                        </v-col>

                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn class="bg-brand w-15" type="submit" ref="searchButton">
                                                Search
                                            </v-btn>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>


        <!-- ================= SALES RETURN LIST TABLE SECTION ================= -->
        <v-container fluid>
            <v-row>
                <v-col cols="12">

                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>

                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Sales Return List
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            clearable
                                        />
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                <v-btn prepend-icon="mdi-download" variant="flat" color="success"
                                                    @click="exportToCSV">CSV</v-btn>

                                                <v-btn prepend-icon="mdi-download" variant="flat" color="primary"
                                                    @click="exportToExcel">EXCEL</v-btn>

                                                <v-btn prepend-icon="mdi-download" variant="flat" color="red"
                                                    @click="exportToPDF">PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn
                                                v-if="$insertAccess($route.fullPath)"
                                                @click="goTo('/inventory/sales-return')"
                                                color="primary"
                                                variant="tonal"
                                                prepend-icon="mdi-plus"
                                                rounded="xl"
                                            >
                                                Create Sales Return
                                            </v-btn>
                                        </div>
                                    </v-col>

                                </v-row>

                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    hover
                                    density="compact"
                                >

                                    <template #item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template #item.status="{ item }">
                                        <v-chip :color="item.status == 1 ? 'success' : 'red'" size="small">
                                            {{ item.status == 1 ? "Active" : "Inactive" }}
                                        </v-chip>
                                    </template>

                                    <template #item.approval_status="{ item }">
                                        <v-chip color="yellow-darken-3" v-if="item.approval_status == 'Pending'" size="small">
                                            Pending
                                        </v-chip>

                                        <v-chip color="green" v-else-if="item.approval_status == 'Approved'" size="small">
                                            Approved
                                        </v-chip>

                                        <v-chip color="red" v-else size="small">
                                            {{ item.approval_status }}
                                        </v-chip>
                                    </template>

                                    <template #item.actions="{ item }">

                                        <v-icon
                                            color="primary"
                                            class="me-2"
                                            @click="editItem(item)"
                                            v-if="canEdit(item)"
                                        >
                                            mdi-pencil-outline
                                        </v-icon>

                                        <v-icon
                                            color="blue"
                                            @click="viewReturnDetails(item)"
                                            title="View Return Details"
                                        >
                                            mdi-file-document-outline
                                        </v-icon>

                                    </template>

                                </v-data-table>

                            </v-expansion-panel-text>

                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        search: "",
        loading: false,

        headers: [
            { title: "#SL", key: "index", align: "center", sortable: false },
            { title: "Code", key: "code", align: "center" },
            { title: "Customer", key: "customer.name", align: "left" },
            { title: "Warehouse", key: "warehouse.name", align: "left" },
            { title: "Amount", key: "amount", align: "end" },
            { title: "Approval Status", key: "approval_status", align: "center" },
            { title: "Status", key: "status", align: "center" },
            { title: "Actions", key: "actions", align: "center", sortable: false },
        ],
    }),

    created() {
        if (this.$store.getters.getCustomerList?.length === 0) {
            this.$store.dispatch("getCustomerList");
        }
        if (this.$store.getters.getWarehouseList?.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
    },

    computed: {
        getSchema() {
            return this.$store.getters.salesReturnRecord || [];
        },
        getCustomerList() {
            return this.$store.getters.getCustomerList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
    },

    setup() {
        const { handleSubmit } = useForm();

        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const customer_id = useField("customer_id");
        const warehouse_id = useField("warehouse_id");

        const store = useStore();
        const loading = ref(false);

        const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);

            store.dispatch("salesReturnRecord", values)
                .then(() => loading.value = false)
                .catch((err) => toast.error(err.response?.data?.message));
        });

        return {
            from_date, to_date, customer_id, warehouse_id, submit, loading,
        };
    },

    methods: {
        goTo(path) {
            this.$router.push({ path });
        },
        editItem(item) {
            this.$router.push({
                name: "sales-return",
                query: { id: item.id },
            });
        },
        canEdit(item){
            return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
        },
        viewReturnDetails(item) {
            this.$router.push({
                name: "sales-return-details",
                params: { id: item.id },
            });
        },

        exportToPDF() {},
        exportToExcel() {},
        exportToCSV() {},
    },

    mounted() {
        this.from_date.value.value = new Date();
        this.to_date.value.value = new Date();

        this.$nextTick(() => {
            this.$refs.searchButton.$el.click();
        });
    },
};
</script>

<style>
.panel-header {
    font-weight: bold;
}
</style>
